import React, { useState, useEffect } from "react";
import { Icon } from "@vds/icons";
import { useDispatch } from "react-redux";
import {
  convertDateFormat,
  fetchEvidenceS3Url,
} from "../../utility/Utils";
import { Loader } from "@vds/loaders";
import { Title } from "@vds/typography";
import { useNavigate } from "react-router-dom";
import ShareEvents from "../Modals/ShareEvents";
import { useRef } from "react";
import {
  EventsTile,
  EventBorder,
  TextElements,
  RightContainer,
  TimeOfEvent,
  NameOfTheEvent,
  CameraNameofEvent,
  CaretButton,
  ExpandedFrame,
  SummaryofEvent,
  TileForVideoPlayer,
  TileForButtons,
  CustomButton,
  TextEllipsis,
} from "./styles";
import {
  getBannerEventsIconOnEventsTile,
} from "../../../model/DashboardFilterService";
import { getCamerabyId, getCameraObjectbyId } from "../../../model/reportService";
import { eventMouseOur } from "../../../store/actions";
import { useSelector } from "react-redux";
import DashboardVideoPlay from "./DashboardVideoPlay";
import { Tooltip } from "@mui/material";
import { setExpandedEvent, clearExpandedEvent, saveEvidenceVideoUrl } from "../../../store/actions/index.jsx";
import { DASHBOARD_TEST_IDS, EVENT_TYPE, EVIDENCE_PROCESSING_MESSAGE, CAMERA_DELETED_MESSAGE } from "../../../pages/Dashboard/dashboardConstants";

const DashboardEventRow = ({
  name,
  summary,
  location,
  eventTime,
  videoEvidence,
  availableVideoEvidence,
  event,
  isFloorPlan = false,
  closeModal,
  evidenceStatus,
  setInitialSiteTag,
  setInitialFloorTag,
  onExpand,
  isExpandedValue,
  onHoverChange,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const evidenceVideoUrls = useSelector((state) => state.imagesReducer.evidenceVideoUrls);
  const [isExpanded, setIsExpanded] = useState(isExpandedValue);
  const [evidenceVideoUrl, setEvidenceVideoUrl] = useState(null);
  const [showShareEvents, setShowShareEvents] = useState({ isOpen: false });
  const [hover, setHover] = useState(false);
  const [deletedCameraTooltip, setDeletedCameraTooltip] = useState(false);
  const tileRef = useRef(null);

  const {
    priority,
    id,
  } = event;

  // Sync internal expansion state with parent's prop
  useEffect(() => {
    setIsExpanded(isExpandedValue);
  }, [isExpandedValue]);

  const getEvidanceData = async (evidence) => {
    const isVideoEvidencePresent = evidence?.id || evidence?.mediaId;
    if (!isVideoEvidencePresent) return;
    const videoId = evidence?.id;

    if (evidence?.mediaId) {
      const cachedS3Url = evidenceVideoUrls[evidence.mediaId];
      const s3Url = cachedS3Url || (await fetchEvidenceS3Url(evidence.mediaId, activeSession))?.URL;
      if (s3Url && !cachedS3Url) dispatch(saveEvidenceVideoUrl(evidence.mediaId, s3Url));
      setEvidenceVideoUrl(s3Url || "");
    }
  };

  useEffect(() => {
    if (tileRef.current) {
      tileRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest"
      });
    }
    
    getEvidanceData(videoEvidence);
  }, [videoEvidence?.id]);

  useEffect(() => {
    if (hover && Object.keys(event).length > 0) {
      if (location?.site?.tag && setInitialSiteTag) {
        setInitialSiteTag(location.site.tag);
      }
      if (location?.floor?.tag && setInitialFloorTag) {
        setInitialFloorTag(location.floor.tag);
      }

      const sourceId = event?.evidences[0]?.sourceId || videoEvidence?.sourceId;
      if (!sourceId) {
        setDeletedCameraTooltip(false);
        dispatch(eventMouseOur(null));
        return;
      }
      const cameraById = getCamerabyId(sourceId);
      const cameraByRefId = getCameraObjectbyId(sourceId);
      // Camera list loaded (Array) AND both lookups empty → camera truly deleted/unpaired
      const isCameraDeleted = Array.isArray(cameraById) && cameraById.length === 0
        && Array.isArray(cameraByRefId) && cameraByRefId.length === 0;

      if (isCameraDeleted) {
        setDeletedCameraTooltip(true);
        dispatch(eventMouseOur(null));
      } else {
        setDeletedCameraTooltip(false);
        dispatch(eventMouseOur(sourceId, event));
      }
    } else {
      setDeletedCameraTooltip(false);
      dispatch(eventMouseOur(null));
    }
  }, [hover]);
  const getEventLocation = () => {
    if (location?.area?.name && location?.floor?.name) {
      return location?.subarea?.name !== "NA"
        ? `${location?.subarea?.name}, ${location?.area?.name}, ${location?.floor?.name}`
        : `${location?.area?.name}, ${location?.floor?.name}`;
    } else {
      return "N/A ";
    }
  };
  const getSiteLocation = () => {
    if (location?.site?.name) {
      return location?.site?.name;
    } else {
      return "N/A";
    }
  };
  const handleMouseEnter = () => {
    if (!isExpanded) {
      setHover(true);
      // Notify parent that a row is being hovered so it can freeze the event list
      // and floor map — prevents new events from shifting the list or switching the
      // floor plan while the user is actively looking at an event row.
      onHoverChange?.(true);
    }
  };

  const handleMouseLeave = () => {
    setHover(false);
    // Notify parent that hover ended — allows list + floor map to resume normal updates.
    onHoverChange?.(false);
  };
  
  const { formatWithTime } = convertDateFormat(eventTime);

  const handleDetailsClick = () => {
    setIsExpanded(false);
    setHover(false);
    navigate(`/eventsInfo?eventid=${id}`);
  };

  const setAccordianExpansion = (event) => {
    if (event?.type === EVENT_TYPE.INCIDENT && evidenceStatus === 1 && videoEvidence) {
      const newExpandedState = !isExpanded;
      setIsExpanded(newExpandedState);
      if(newExpandedState){
        dispatch(setExpandedEvent(event));
        onExpand(event, true);
      } else {
        dispatch(clearExpandedEvent());
        onExpand(event, false);
      }
    } else {
      handleDetailsClick();
    }
  };
  const siteLocation = getSiteLocation();
  const eventLocation = getEventLocation();
  return (
    <Tooltip
      open={deletedCameraTooltip}
      title={CAMERA_DELETED_MESSAGE}
      placement="top"
      arrow
      disableFocusListener
      disableHoverListener
      disableTouchListener
    >
    <div onClick={() => {
                    setAccordianExpansion(event);
                  }}>
      <ShareEvents
        setShowShareEvents={setShowShareEvents}
        showShareEvents={showShareEvents}
      />
      <EventsTile
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        isHighlighted={hover}
        isExpanded={isExpanded}
        isFloorPlan={isFloorPlan}
        isHighPriority={priority === "Critical"}
      >
        <EventBorder style={isFloorPlan ? { width: "308px" } : {}}>
          <TextElements
            data-testid={DASHBOARD_TEST_IDS.DASHBOARD_ACCORDION_ITEM}
          >
            <TimeOfEvent>
              {priority === "Critical" && (
                <img
                  src={getBannerEventsIconOnEventsTile(event)}
                  alt=""
                  style={{
                    marginRight: "8px",
                    marginBottom: "10px",
                    width: "25px",
                    height: "25px",
                  }}
                />
              )}
              {formatWithTime}
            </TimeOfEvent>
            <NameOfTheEvent>
              <Tooltip title={name}>
                <TextEllipsis>{name}</TextEllipsis>
              </Tooltip>
            </NameOfTheEvent>
            <CameraNameofEvent>
              <Tooltip title={eventLocation}>
                <TextEllipsis>{eventLocation}</TextEllipsis>
              </Tooltip>
              <Tooltip title={siteLocation}>
                <TextEllipsis>
                  {siteLocation}
                </TextEllipsis>
              </Tooltip>
            </CameraNameofEvent>
          </TextElements>
          <RightContainer
            style={isFloorPlan ? { marginLeft: "-120px", padding: "30px" } : {}}
          >
            {!isFloorPlan && (event?.type === EVENT_TYPE.INCIDENT) && (
              evidenceStatus === 1 && videoEvidence ? (
                <CaretButton data-testid={DASHBOARD_TEST_IDS.DASHBOARD_ACCORDION_ITEM_EXPAND_BUTTON}>
                  {isExpanded ? (
                    <Icon name="up-caret" size="XLarge" color="#000000" />
                  ) : (
                    <Icon name="down-caret" size="XLarge" color="#000000" />
                  )}
                </CaretButton>
              ) : (
                <Tooltip title={EVIDENCE_PROCESSING_MESSAGE}>
                  <span className="wait-for-evidence">
                    <Icon name="clock" size="20px" color="#A7A7A7" />
                  </span>
                </Tooltip>
              )
            )}
            {isFloorPlan && event?.type !== EVENT_TYPE.SMART_ALERT && (
              <CaretButton
                data-testid={DASHBOARD_TEST_IDS.DASHBOARD_ACCORDION_ITEM_CLOSE_BUTTON}
                onClick={() => closeModal()}
              >
                <Icon name="close" size="medium" color="#000000" />
              </CaretButton>
            )}
          </RightContainer>
        </EventBorder>
        <ExpandedFrame $isExpanded={isExpanded}>
            {evidenceVideoUrl === "" && (
              <div style={{ margin: "20px auto" }}>
                <Title size="medium">Video evidence Not found</Title>
              </div>
            )}
            {evidenceVideoUrl === null && (
              <div
                style={
                  !isFloorPlan
                    ? {
                        minHeight: "200px",
                        width: "100%",
                        position: "relative",
                      }
                    : {
                        maxHeight: "170px",
                        minHeight: "150px",
                        width: "100%",
                        position: "relative",
                      }
                }
              >
                <Loader active={evidenceVideoUrl === null} />
              </div>
            )}

            <TileForVideoPlayer
              style={isFloorPlan ? { height: "170px" } : { height: "auto" }}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
            >
              {evidenceVideoUrl && (
                <DashboardVideoPlay
                  evidenceUrl={evidenceVideoUrl}
                  type="video/mp4"
                  isAccordionExpanded={isExpanded}
                >
                  Your browser does not support the video tag.
                </DashboardVideoPlay>
              )}
            </TileForVideoPlayer>
            <TileForButtons
              ref={tileRef}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
            >
              <CustomButton
                style={isFloorPlan ? { padding: "0px" } : {}}
                surface="light"
                size="large"
                state="default"
                width="auto"
                onClick={handleDetailsClick}
                data-testid={DASHBOARD_TEST_IDS.DASHBOARD_ACCORDION_ITEM_DETAILS_BUTTON}
              >
                Details
              </CustomButton>
            </TileForButtons>
          </ExpandedFrame>
      </EventsTile>
    </div>
    </Tooltip>
  );
};

const propsAreEqual = (prevProps, nextProps) => {
  const prevEventId = prevProps.event?.id;
  const nextEventId = nextProps.event?.id;

  // If the event id changed, re-render this row
  if (prevEventId !== nextEventId) return false;

  // If expansion control changed, re-render
  if (prevProps.isExpandedValue !== nextProps.isExpandedValue) return false;

  // If evidence status changed, re-render
  if (prevProps.evidenceStatus !== nextProps.evidenceStatus) return false;

  // If the video evidence id changed for this event, re-render
  const prevVideoId = prevProps.videoEvidence?.id;
  const nextVideoId = nextProps.videoEvidence?.id;
  if (prevVideoId !== nextVideoId) return false;

  // If the resolved streaming URL changed for the same video id, re-render
  const getUrlFor = (list, id) => {
    if (!list || !id) return null;
    const it = list.find((i) => i?.id === id);
    return it?.url ?? null;
  };
  const prevUrl = getUrlFor(prevProps.availableVideoEvidence, prevVideoId);
  const nextUrl = getUrlFor(nextProps.availableVideoEvidence, nextVideoId);
  if (prevUrl !== nextUrl) return false;

  // All relevant values unchanged — skip re-render
  return true;
};

export default React.memo(DashboardEventRow, propsAreEqual);
